import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f07e3c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  ref: "list",
  class: "list"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "box_card" }
const _hoisted_4 = { class: "image" }
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "date" }
const _hoisted_7 = { class: "box_qr" }
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" 扫码添加小助手，回复“白皮书”"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" 获取更多行业干货 ")
], -1 /* HOISTED */))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_pagination = _resolveComponent("a-pagination")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_a_row, { gutter: [20,0] }, {
        default: _withCtx(() => [
          _createVNode(_component_a_col, {
            xs: 24,
            xl: 16
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_skeleton, {
                loading: $data.request.data.list.length===0,
                active: ""
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.request.data.list, (item) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        class: "card",
                        to: `${_ctx.$Enum.RouterEnum.NewsDetail}?id=${item.article_id}`
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: [20,0] }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, {
                                xs: 0,
                                sm: 10,
                                md: 8
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("i", {
                                      style: _normalizeStyle({backgroundImage:`url('${item.article_cover_address}')`})
                                    }, null, 4 /* STYLE */)
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */),
                              _createVNode(_component_a_col, {
                                xs: 24,
                                sm: 14,
                                md: 16
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, [
                                    _createVNode(_component_a_typography_title, { level: 5 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.article_title), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    _createVNode(_component_a_typography_paragraph, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item.article_introduction), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */),
                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$FN.Time.format(item.published_at * 1000)), 1 /* TEXT */)
                                  ])
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1024 /* DYNAMIC_SLOTS */)
                            ]),
                            _: 2 /* DYNAMIC */
                          }, 1024 /* DYNAMIC_SLOTS */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"]))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ]),
                  _createVNode(_component_a_pagination, {
                    current: $data.expand.pagination.current,
                    "onUpdate:current": _cache[0] || (_cache[0] = ($event: any) => (($data.expand.pagination.current) = $event)),
                    size: _ctx.$Store.Public().width<_ctx.$Enum.GridEnum.MD?'small':'',
                    total: $data.expand.pagination.total,
                    pageSize: $data.expand.pagination.pageSize,
                    pageSizeOptions: ['10', '20', '50'],
                    onChange: $data.expand.pagination.onChange,
                    showLessItems: "",
                    showQuickJumper: "",
                    showSizeChanger: ""
                  }, null, 8 /* PROPS */, ["current", "size", "total", "pageSize", "onChange"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["loading"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_a_col, {
            xs: 0,
            xl: 8
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("img", {
                  alt: "",
                  src: $data.file.ImageQR
                }, null, 8 /* PROPS */, _hoisted_8),
                _hoisted_9,
                _hoisted_10
              ])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ])
  ], 512 /* NEED_PATCH */))
}